import CategoryList from "../container/category/CategoryList";
import Category from "../container/category/Form";
import Dashboard from "../container/dashboard/Dashboard";
import File from "../container/file/Form";
import FileList from "../container/file/FileList";
import Product from "../container/product/Form";
import ProductList from "../container/product/ProductList";
import User from "../container/user/Form";
import UserList from "../container/user/UserList";
import AffiliateDetail from "../container/user/AffiliateDetail";
import ProductShipping from "../container/product-shipping/Form";
import ProductShippingList from "../container/product-shipping/ProductShippingList";
import Discount from "../container/discount/Form";
import OrderList from "../container/orders/OrderList";
import ShowSingleOrder from "../container/orders/ShowSingleOrder";
import Coupon from "../container/coupon/Form";
import CouponList from "../container/coupon/CouponList";
import LearnCategory from "../container/leran-category/Form";
import LearnCategoryList from "../container/leran-category/LearnCategoryList";
import Learn from "../container/learn/Form";
import LearnList from "../container/learn/LearnList";
import Export from "../container/export/Export";
import Article from "../container/article/Form";
import ArticleList from "../container/article/ArticleList";
import Deposit from "../container/wallets/Form";
import WalletsTransaction from "../container/wallets/WalletsTransaction";
import EditTransaction from "../container/wallets/EditTransaction";
import ProductsReports from "../container/reports/products-reports/ProductsReports";
import UsersReports from "../container/reports/users-reports/UsersReports";
import OrdersReports from "../container/reports/orders-reports/OrdersReports";
import ProvinceList from "../container/province-and-city/ProvinceList";
import EditCities from "../container/province-and-city/Form";
import BarcodesUpload from "../container/orders/BarcodesUpload";
import SaboraOrderList from "../container/orders/SaboraOrderList";
import SaboraBarcodesUpload from "../container/orders/SaboraBarcodesUpload";
import UsersOldReports from "../container/reports/users-reports/UsersOldReports";
import UsersReportsMounthly from "../container/reports/users-reports-mounthly/UsersMounthlySalesReports";
import AllOrderReports from "../container/reports/all-orders-reports/AllOrdersReports";
import CampainOrderGiftDiscountForm from "../container/discount/CampainOrderGiftDiscountForm";
import CampainOrderGiftDiscountList from "../container/discount/CampainOrderGiftDiscountList";
import Slider from "../container/slider/Form";
import SliderList from "../container/slider/SliderList";
import SmsForm from "../container/sms/Form";
import SmsList from "../container/sms/SmsList";
import UserFirstSalesReports from "../container/reports/user-first-customer/UserFirstCustomerReports";
import TotalUserCustomerCountReports from "../container/reports/total-user-customer-count/totalUserCustomerCountReports";
import UserCustomers from "../container/reports/user-customers/userCustomersReports";
import InactiveUserCustomersReports from "../container/reports/inactive-user-customers/InactiveUserCustomersReports";
import FAQ from "../container/faq/Form";
import FaqList from "../container/faq/FaqList";
import TermsForm from "../container/terms/Form";
import TermsList from "../container/terms/TermsList";
import TeamMemberForm from "../container/team-member/Form";
import TeamMemberList from "../container/team-member/TeamMemberList";
import BackupList from "../container/backup/BackupList";
import OrdersUniqueMobileSalesReport from "../container/reports/orders-uniqe-mobile-sales-reports/OrdersUniqueMobileSalesReport";
import AllUserCommisionsReport from "../container/reports/all-users-commision.ts/AllUserCommisionsReport";
import ProductStockList from "../container/product-stock/ProductStockList";
import SocialMediaCustomerReport from "../container/reports/social-media-customer/socialMediaCustomerReport";
import PublicFieldForm from "../container/public-fields/Form";
import AdminActivityList from "../container/admin-activity/AdminActivityList";
import ReviewsList from "../container/reviews/ReviewsList";
import AffiliateRequestList from "../container/affiliate-request/AffiliateRequestList";
import AffiliateFaqList from "../container/affiliate-faq/AffiliateFaqList";
import AffiliateFaqForm from "../container/affiliate-faq/Form";
import AffiliateBenefitList from "../container/affiliate-benefit/AffiliateBenefitList";
import AffiliateBenefitForm from "../container/affiliate-benefit/Form";
import AffiliateSettingsForm from "../container/affiliate-settings/Form";
import AboutSettingsForm from "../container/about-settings/Form";
import TestimonialList from "../container/affiliate-testimonials/TestimonialList";
import TestimonialForm from "../container/affiliate-testimonials/Form";
import CustomerExperienceList from "../container/customer-experiences/CustomerExperienceList";
import AffiliateServiceList from "../container/affiliate-service/AffiliateServiceList";
import AffiliateServiceForm from "../container/affiliate-service/Form";
import ContactMessageList from "../container/contact-message/ContactMessageList";

export const routes = [
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/add-user",
    component: <User />,
  },
  {
    path: "/edit-user",
    component: <User />,
  },
  {
    path: "/user-list",
    component: <UserList />,
  },
  {
    path: "/affiliate-detail",
    component: <AffiliateDetail />,
  },
  {
    path: "/add-category",
    component: <Category />,
  },
  {
    path: "/edit-category",
    component: <Category />,
  },
  {
    path: "/category-list",
    component: <CategoryList />,
  },
  {
    path: "/add-learn-category",
    component: <LearnCategory />,
  },
  {
    path: "/edit-learn-category",
    component: <LearnCategory />,
  },
  {
    path: "/learn-category-list",
    component: <LearnCategoryList />,
  },
  {
    path: "/add-product",
    component: <Product />,
  },
  {
    path: "/edit-product",
    component: <Product />,
  },
  {
    path: "/product/:id",
    component: <Product />,
  },
  {
    path: "/product-list",
    component: <ProductList />,
  },
  {
    path: "/file",
    component: <File />,
  },
  {
    path: "/file-list",
    component: <FileList />,
  },
  {
    path: "/add-product-shipping",
    component: <ProductShipping />,
  },
  {
    path: "/edit-product-shipping",
    component: <ProductShipping />,
  },
  {
    path: "/product-shipping-list",
    component: <ProductShippingList />,
  },
  {
    path: "/discount-manage",
    component: <Discount />,
  },
  {
    path: "/gift-order-product-form",
    component: <CampainOrderGiftDiscountForm />,
  },
  {
    path: "/gift-order-product-list",
    component: <CampainOrderGiftDiscountList />,
  },
  {
    path: "/order-list",
    component: <OrderList />,
  },
  {
    path: "/order-list/:id",
    component: <ShowSingleOrder />,
  },
  {
    path: "/add-coupon",
    component: <Coupon />,
  },
  {
    path: "/edit-coupon",
    component: <Coupon />,
  },
  {
    path: "/coupon-list",
    component: <CouponList />,
  },
  {
    path: "/add-learn",
    component: <Learn />,
  },
  {
    path: "/edit-learn",
    component: <Learn />,
  },
  {
    path: "/learn-list",
    component: <LearnList />,
  },
  {
    path: "/export",
    component: <Export />,
  },
  {
    path: "/add-article",
    component: <Article />,
  },
  {
    path: "/edit-article",
    component: <Article />,
  },
  {
    path: "/article-list",
    component: <ArticleList />,
  },
  {
    path: "/add-deposit",
    component: <Deposit />,
  },
  {
    path: "/wallets-transaction",
    component: <WalletsTransaction />,
  },
  {
    path: "/edit-transaction/:id",
    component: <EditTransaction />,
  },
  {
    path: "/reports/products",
    component: <ProductsReports />,
  },
  {
    path: "/product-stocks-lis",
    component: <ProductStockList />,
  },

  {
    path: "/reports/orders",
    component: <OrdersReports />,
  },
  {
    path: "/reports/users",
    component: <UsersReports />,
  },
  {
    path: "/reports/all-orders",
    component: <AllOrderReports />,
  },
  {
    path: "/reports/usersMounthly",
    component: <UsersReportsMounthly />,
  },
  {
    path: "/reports/users-summer",
    component: <UsersOldReports />,
  },
  {
    path: "/reports/users-first-sales",
    component: <UserFirstSalesReports />,
  },
  {
    path: "/reports/users-customer-counts",
    component: <TotalUserCustomerCountReports />,
  },
  {
    path: "/reports/users-customers-list",
    component: <UserCustomers />,
  },
  {
    path: "/reports/inactive-users-customers",
    component: <InactiveUserCustomersReports />,
  },
  {
    path: "/reports/orders-unique-mobile-sales",
    component: <OrdersUniqueMobileSalesReport />,
  },
  {
    path: "/reports/all-users-commisions",
    component: <AllUserCommisionsReport />,
  },
  {
    path: "/reports/social-media-customer",
    component: <SocialMediaCustomerReport />,
  },
  {
    path: "/add-slider",
    component: <Slider />,
  },
  {
    path: "/edit-slider",
    component: <Slider />,
  },
  {
    path: "/slider-list",
    component: <SliderList />,
  },
  {
    path: "/province-list",
    component: <ProvinceList />,
  },
  {
    path: "/edit-cities",
    component: <EditCities />,
  },
  {
    path: "/barcodes-upload",
    component: <BarcodesUpload />,
  },
  {
    path: "/sabora-order-list",
    component: <SaboraOrderList />,
  },
  {
    path: "/sabora-order-list/:id",
    component: <ShowSingleOrder />,
  },
  {
    path: "/sabora-barcodes-upload",
    component: <SaboraBarcodesUpload />,
  },
  {
    path: "/add-sms",
    component: <SmsForm />,
  },
  {
    path: "/edit-sms",
    component: <SmsForm />,
  },
  {
    path: "/sms-list",
    component: <SmsList />,
  },
  {
    path: "/add-faq",
    component: <FAQ />,
  },
  {
    path: "/edit-faq",
    component: <FAQ />,
  },
  {
    path: "/faq-list",
    component: <FaqList />,
  },
  {
    path: "/add-team-member",
    component: <TeamMemberForm />,
  },
  {
    path: "/edit-team-member",
    component: <TeamMemberForm />,
  },
  {
    path: "/team-member-list",
    component: <TeamMemberList />,
  },
  {
    path: "/add-terms",
    component: <TermsForm />,
  },
  {
    path: "/edit-terms",
    component: <TermsForm />,
  },
  {
    path: "/terms-list",
    component: <TermsList />,
  },
  {
    path: "/backup-list",
    component: <BackupList />,
  },
  {
    path: "/public-field-manage",
    component: <PublicFieldForm />,
  },
  {
    path: "/admin-activities",
    component: <AdminActivityList />,
  },
  {
    path: "/reviews-list",
    component: <ReviewsList />,
  },
  {
    path: "/affiliate-request-list",
    component: <AffiliateRequestList />,
  },
  {
    path: "/contact-message-list",
    component: <ContactMessageList />,
  },
  {
    path: "/affiliate-faq-list",
    component: <AffiliateFaqList />,
  },
  {
    path: "/add-affiliate-faq",
    component: <AffiliateFaqForm />,
  },
  {
    path: "/edit-affiliate-faq",
    component: <AffiliateFaqForm />,
  },
  {
    path: "/affiliate-benefit-list",
    component: <AffiliateBenefitList />,
  },
  {
    path: "/add-affiliate-benefit",
    component: <AffiliateBenefitForm />,
  },
  {
    path: "/edit-affiliate-benefit",
    component: <AffiliateBenefitForm />,
  },
  {
    path: "/affiliate-settings",
    component: <AffiliateSettingsForm />,
  },
  {
    path: "/about-settings",
    component: <AboutSettingsForm />,
  },
  {
    path: "/affiliate-testimonial-list",
    component: <TestimonialList />,
  },
  {
    path: "/add-affiliate-testimonial",
    component: <TestimonialForm />,
  },
  {
    path: "/edit-affiliate-testimonial",
    component: <TestimonialForm />,
  },
  {
    path: "/customer-experience-list",
    component: <CustomerExperienceList />,
  },
  {
    path: "/affiliate-service-list",
    component: <AffiliateServiceList />,
  },
  {
    path: "/add-affiliate-service",
    component: <AffiliateServiceForm />,
  },
  {
    path: "/edit-affiliate-service",
    component: <AffiliateServiceForm />,
  },
];
